import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../../route.animation';
import {GeneralService} from '../../../../_services/general.service';
import {InspectorsCalibration} from '../../../../_interfaces/inspectors/inspectors-calibration';
import {InspectorsService} from '../../../../_services/inspectors.service';
import {ApiService} from '../../../../_interceptors/api.service';

@Component({
	selector: 'app-inspectors-calibrations-list',
	templateUrl: './calibrations-list.component.html',
	styleUrls: ['./calibrations-list.component.scss'],
	animations: [routeAnimation]
})

export class InspectorsCalibrationsListComponent implements OnInit, OnDestroy {

	@HostBinding('@routeAnimation') routerTransition = true;

	private totalItems: number = 0;
	private currentPage: number = 0;
	private searchString: string = '';
	private isLoading: boolean = false;
	private keepLoading: boolean = false;

	public inspectorsCalibrations: InspectorsCalibration[] = [];

	constructor(private inspectorsService: InspectorsService,
				private apiService: ApiService,
				private generalService: GeneralService) {
	}

	ngOnInit(): void {
		this.apiService.connectionChanged.subscribe(online => {
			if (online && !this.inspectorsCalibrations.length) {
				this.currentPage = 0;
				this.getInspectorsCalibrations(false);
			}
		});

		this.getInspectorsCalibrations(false);
	}

	ngOnDestroy(): void {
		this.totalItems = 0;
		this.currentPage = 0;
		this.searchString = '';
		this.inspectorsCalibrations = [];
	}

	getInspectorsCalibrations(append_data: boolean = true) {
		if (!this.isLoading || this.keepLoading) {
			this.isLoading = true;
			this.keepLoading = false;
			this.currentPage++;

			this.inspectorsService.getInspectorsCalibrations({
				start: (this.currentPage - 1) * this.generalService.itemsPerPage,
				length: this.generalService.itemsPerPage,
				'columns[3][search][value]': this.searchString
			}).then((data: any) => {
				if (typeof data !== 'undefined') {
					if (typeof data.recordsTotal !== 'undefined') {
						this.totalItems = data.recordsTotal;
					}
					if (append_data === true) {
						this.inspectorsCalibrations.push(...<InspectorsCalibration[]>data.data);
					} else {
						this.inspectorsCalibrations = <InspectorsCalibration[]>data.data;
					}
				}
				this.isLoading = false;
			});
		}
	}

	deleteInspectorCalibration(client_id: number) {
		this.inspectorsService.deleteInspectorCalibration(client_id).then(status => {
			if (status === true) {
				let index = this.inspectorsCalibrations.findIndex(data => data.id === client_id);

				if (index !== -1) {
					this.inspectorsCalibrations.splice(index, 1);
				}
			}
		});
	}

	search($event) {
		this.searchString = $event;
		this.currentPage = 0;
		this.getInspectorsCalibrations(false);
	}
}
